import type { FC } from "react"
import { Text, Stack, Link, Button, Icon, HStack } from "@chakra-ui/react"

import CardContainer from "common/components/CardContainer"
import type { Organization } from "query/graphql"
import { getMirroredProposal } from "proposal/constants/mirrored-proposal"
import { ArrowUpRight } from "ui/components/icons/font-awesome/ArrowUpRight"

type Props = {
  organization: Organization
  proposalId: string
}
const ProposalMirrored: FC<Props> = ({ organization, proposalId }) => {
  const proposalMirroredRef = getMirroredProposal(organization.id)

  if (!proposalMirroredRef) return null

  const proposalUrl = proposalMirroredRef.externalProposalUrl.replace(
    "{tallyProposalId}",
    proposalId,
  )

  return (
    <CardContainer isFullHeightView title="Mirrored proposal">
      <Stack>
        <Text fontSize="md">{proposalMirroredRef.message}</Text>
        <Button
          isExternal
          as={Link}
          className="no-underline"
          href={proposalUrl}
          variant="secondary"
        >
          <HStack align="center" spacing={2}>
            <Text color="gray.600" fontSize="sm">
              {proposalMirroredRef.ctaLabel}
            </Text>
            <Icon as={ArrowUpRight} h={3} w={3} />
          </HStack>
        </Button>
      </Stack>
    </CardContainer>
  )
}

export default ProposalMirrored
